export default __webpack_public_path__ + "static/media/element_83.001f0ebf.jpg";